import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { GetExistenciaIndividual } from "../../../../hooks/getExistenciasIndividuales";
import { ThemeContext } from "@emotion/react";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  Search,
} from "@mui/icons-material";
import { GetCertificadosPanel } from "../../../../hooks/certificadosPanel";
import { enqueueSnackbar } from "notistack";
import { useLoading } from "../../../../components/Loading/useLoading";
import useApi from "../../../../hooks/useApiRequest";
import { AreaAlmacenEnum } from "../../../../@enums/tipo_almacen";

const TablaGeneral = ({
  sample,
  setAyudasVisuales,
  setOpenAyudas,
  almacen,
  filtro,
  handleInputChange,
  onPressEnter,
  canSearch,
  isVerifying,
  areaAlma,
  color
}) => {
  const theme = useContext(ThemeContext);
  const rows = sample;
  const api = useApi();

  const [openRows, setOpenRows] = useState({});
  const [movimientosData, setMovimientosData] = useState({});

  const toggleRow = (partId) => {
    setOpenRows((prev) => ({
      ...prev,
      [partId]: !prev[partId],
    }));
  };

  const setMovimientosForRow = (partId, data) => {
    setMovimientosData((prev) => ({
      ...prev,
      [partId]: data,
    }));
  };

  const VerSerial = ({ data }) => {
    const seriales = data;

    const Title = () => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          {seriales.map((item) => (
            <span>{item}</span>
          ))}
        </div>
      );
    };

    return (
      <Tooltip title={<Title />} placement="top" arrow>
        <Button variant="text">Ver Seriales</Button>
      </Tooltip>
    );
  };

  // const Row = (props) => {
  //   const { row } = props;
  //   const { getExistenciaIndividualMutation } = GetExistenciaIndividual();
  //   const { setAppLoading } = useLoading();
  //   const open = openRows[row.part_id] || false;
  //   const movimientos = movimientosData[row.part_id] || [];

  //   const getResources = (id) => {
  //     setAyudasVisuales(id);
  //     setOpenAyudas(true);
  //   };

  //   const get_movimientos = (id_parte) => {
  //     setAppLoading(true);
  //     setTimeout(() => {
  //       getExistenciaIndividualMutation({ almacen: almacen, parte: id_parte }, {
  //         onSuccess: (data) => {
  //           const processedData = data.map(mov => {
  //             let seriales = new Set(mov?.moin_serial);
  //             return { ...mov, moin_serial: [...seriales] };
  //           });
  //           setMovimientosForRow(id_parte, processedData);
  //         },
  //         onError: (error) => {
  //           console.log(error);
  //         },
  //         onSettled: () => { setAppLoading(false); }
  //       });
  //     }, 500);
  //   };

  //   const open_subtabla = (id_parte) => {
  //     if (open) {
  //       toggleRow(id_parte);
  //       setMovimientosForRow(id_parte, []);
  //     } else {
  //       get_movimientos(id_parte);
  //       toggleRow(id_parte);
  //     }
  //   };

  //   const downloadCertificates = async (etiqueta) => {
  //     if (isVerifying) {
  //       console.log('Esperando verificación del padre...');
  //       return;
  //     }
  //     setAppLoading(true)
  //     try {
  //       const response = await api.get(`/administracion-inventario/certificado/panel/${etiqueta}/${almacen}`, {
  //         responseType: 'blob', // Indicamos que esperamos un archivo binario (blob)
  //       });
  //       // Obtener el encabezado Content-Disposition
  //       const contentDisposition = response.headers['content-disposition'];

  //       // Extraer el nombre del archivo del encabezado
  //       const fileName = contentDisposition
  //         ? contentDisposition.split('filename=')[1].replace(/['"]/g, '')
  //         : 'certificates.zip'; // Valor por defecto si no se encuentra el nombre del archivo

  //       // Crear un URL para el archivo descargado
  //       const url = window.URL.createObjectURL(new Blob([response.data]));

  //       // Crear un enlace para descargar el archivo
  //       const link = document.createElement('a');
  //       link.href = url;

  //       // Asignar un nombre al archivo descargado
  //       link.setAttribute('download', fileName);

  //       // Añadir el enlace al documento y hacer clic en él para descargar el archivo
  //       document.body.appendChild(link);
  //       link.click();

  //       // Limpiar el DOM
  //       document.body.removeChild(link);
  //       setAppLoading(false)
  //       enqueueSnackbar('Certificados descargados', { variant: 'success', preventDuplicate: true, autoHideDuration: 2000, anchorOrigin: { vertical: 'top', horizontal: 'center' } });
  //     } catch (error) {
  //       setAppLoading(false)
  //       console.error('Error descargando el archivo:', error);
  //       enqueueSnackbar('Error al descargar los certificados', { variant: 'error', preventDuplicate: true, autoHideDuration: 2000, anchorOrigin: { vertical: 'top', horizontal: 'center' } });
  //     }
  //   }

  //   return (
  //     <React.Fragment>
  //       <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
  //         <TableCell sx={{ p: 1 }}>
  //           <IconButton
  //             aria-label="expand row"
  //             size="small"
  //             onClick={() => open_subtabla(row?.part_id)}
  //           >
  //             {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
  //           </IconButton>
  //         </TableCell>
  //         <TableCell
  //           align="center"
  //           onClick={() => getResources(row["part_id"])}
  //           sx={{
  //             display: "table-cell",
  //             fontWeight: 500,
  //             color: theme.palette.primary.input,
  //             background: "white",
  //             p: 1, userSelect: 'text'
  //           }}
  //         >
  //           {row.codigo}
  //         </TableCell>
  //         <TableCell
  //           align="center"
  //           onClick={() => getResources(row["part_id"])}
  //           sx={{
  //             display: "table-cell",
  //             fontWeight: 500,
  //             color: theme.palette.primary.input,
  //             background: "white",
  //             p: 1, userSelect: 'text'
  //           }}
  //         >
  //           {row.nombre}
  //         </TableCell>
  //         <TableCell
  //           align="center"
  //           onClick={() => getResources(row["part_id"])}
  //           sx={{
  //             display: "table-cell",
  //             fontWeight: 500,
  //             color: theme.palette.primary.input,
  //             background: "white",
  //             p: 1, userSelect: 'text'
  //           }}
  //         >
  //           {row.existencia_total}
  //         </TableCell>
  //         <TableCell
  //           align="center"
  //           sx={{
  //             display: "table-cell",
  //             fontWeight: 500,
  //             color: theme.palette.primary.input,
  //             background: "white",
  //             p: 1, userSelect: 'text'
  //           }}
  //         >
  //           {row.cliente}
  //         </TableCell>
  //       </TableRow>
  //       <TableRow>
  //         <TableCell style={{ paddingBottom: 0, paddingTop: 0, marginBottom: 10 }} colSpan={6}>
  //           <Collapse in={open} unmountOnExi={false}>
  //             <Box sx={{ margin: 1 }}>
  //               <Typography variant="h6" gutterBottom component="div">
  //                 Desgloce de contenedores
  //               </Typography>
  //               <Table size="small" aria-label="purchases">
  //                 <TableHead>
  //                   <TableRow>
  //                     <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16, userSelect: 'text' }}>Serial</TableCell>
  //                     <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16, userSelect: 'text' }}>Etiqueta</TableCell>
  //                     <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16, userSelect: 'text' }}>Etiqueta master</TableCell>
  //                     <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16, userSelect: 'text' }}>Cantidad</TableCell>
  //                     <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16, userSelect: 'text' }}>Fecha reporteo</TableCell>
  //                     <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16, userSelect: 'text' }}>Fecha impresión</TableCell>
  //                     <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16, userSelect: 'text' }}>Usuario impresión</TableCell>
  //                     {canSearch && (
  //                       <TableCell align="center" sx={{ color: theme.palette.primary.main, fontSize: 16 }}></TableCell>
  //                     )}
  //                   </TableRow>
  //                 </TableHead>
  //                 <TableBody>
  //                   {movimientos?.map((mov) => (
  //                     <TableRow key={mov?.moin_id}>
  //                       <TableCell align="center" sx={{ pl: 0, pr: 0, pt: 1, pb: 1, userSelect: 'text' }}>{mov?.moin_serial.length === 1 ? mov?.moin_serial[0] : <VerSerial key={`serial_${mov?.moin_id}`} data={mov?.moin_serial} />}</TableCell>
  //                       <TableCell align="center" sx={{ pl: 1.8, pr: 1.8, pt: 1, pb: 1, userSelect: 'text' }}>{mov?.etiq_codigo}</TableCell>
  //                       <TableCell align="center" sx={{ pl: 1.8, pr: 1.8, pt: 1, pb: 1, userSelect: 'text' }}>{mov?.etiq_master}</TableCell>
  //                       <TableCell align="center" sx={{ pl: 0, pr: 0, pt: 1, pb: 1, userSelect: 'text' }}>{mov?.moin_cantidad}</TableCell>
  //                       <TableCell align="center" sx={{ pl: 0, pr: 0, pt: 1, pb: 1, userSelect: 'text' }}>{mov?.moin_fechareportado ? mov?.moin_fechareportado : null}</TableCell>
  //                       <TableCell align="center" sx={{ pl: 0, pr: 0, pt: 1, pb: 1, userSelect: 'text' }}>{mov?.etiq_fechaimpresion ? mov?.etiq_fechaimpresion : null}</TableCell>
  //                       <TableCell align="center" sx={{ pl: 0, pr: 0, pt: 1, pb: 1, userSelect: 'text' }}>{mov?.user}</TableCell>
  //                       {canSearch && (
  //                         <TableCell align="center" sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
  //                           <Button variant="contained"
  //                             key={`certificado_${mov?.etiq_codigo}`}
  //                             className="btn_system"
  //                             sx={{ fontSize: 12, height: 35 }}
  //                             disableElevation
  //                             onClick={() => downloadCertificates(mov?.etiq_codigo)}
  //                           >
  //                             Certificado
  //                           </Button>
  //                         </TableCell>
  //                       )}
  //                     </TableRow>
  //                   ))}
  //                 </TableBody>
  //               </Table>
  //             </Box>
  //           </Collapse>
  //         </TableCell>
  //       </TableRow>
  //     </React.Fragment>
  //   );
  // }

  const Row = (props) => {
    const { row } = props;
    const { getExistenciaIndividualMutation } = GetExistenciaIndividual();
    const { getCertificadosPanelMutation } = GetCertificadosPanel();
    const { setAppLoading } = useLoading();
    const [open, setOpen] = useState(false);
    const [movimientos, setMovimientos] = useState([]);

    const getResources = (id) => {
      setAyudasVisuales(id);
      setOpenAyudas(true);
    };

    const get_movimientos = (id_parte) => {
      getExistenciaIndividualMutation(
        { almacen: almacen, parte: id_parte },
        {
          onSuccess: (data) => {
            for (let mov of data) {
              let seriales = new Set(mov?.moin_serial);
              mov.moin_serial = [...seriales];
            }
            setMovimientos(data);
          },
          onError: (error) => {
            console.log(error);
          },
        },
      );
    };

    const open_subtabla = (id_parte) => {
      if (open) {
        setOpen(!open);
        setMovimientos([]);
      } else {
        get_movimientos(id_parte);
        setOpen(!open);
      }
    };

    const downloadCertificates = async (etiqueta) => {
      setAppLoading(true);
      try {
        const response = await api.get(
          `/administracion-inventario/certificado/panel/${etiqueta}/${almacen}`,
          {
            responseType: "blob", // Indicamos que esperamos un archivo binario (blob)
          },
        );
        // Obtener el encabezado Content-Disposition
        const contentDisposition = response.headers["content-disposition"];

        // Extraer el nombre del archivo del encabezado
        const fileName = contentDisposition
          ? contentDisposition.split("filename=")[1].replace(/['"]/g, "")
          : "certificates.zip"; // Valor por defecto si no se encuentra el nombre del archivo

        // Crear un URL para el archivo descargado
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Crear un enlace para descargar el archivo
        const link = document.createElement("a");
        link.href = url;

        // Asignar un nombre al archivo descargado
        link.setAttribute("download", fileName);

        // Añadir el enlace al documento y hacer clic en él para descargar el archivo
        document.body.appendChild(link);
        link.click();

        // Limpiar el DOM
        document.body.removeChild(link);
        setAppLoading(false);
        enqueueSnackbar("Certificados descargados", {
          variant: "success",
          preventDuplicate: true,
          autoHideDuration: 2000,
          anchorOrigin: { vertical: "top", horizontal: "center" },
        });
      } catch (error) {
        setAppLoading(false);
        console.error("Error descargando el archivo:", error);
        enqueueSnackbar("Error al descargar los certificados", {
          variant: "error",
          preventDuplicate: true,
          autoHideDuration: 2000,
          anchorOrigin: { vertical: "top", horizontal: "center" },
        });
      }
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell sx={{ p: 1 }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => open_subtabla(row?.part_id)}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
          <TableCell
            align="center"
            onClick={() => getResources(row["part_id"])}
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1,
            }}
          >
            {row.codigo}
          </TableCell>
          <TableCell
            align="center"
            onClick={() => getResources(row["part_id"])}
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1,
            }}
          >
            {row.nombre}
          </TableCell>
          <TableCell
            align="center"
            onClick={() => getResources(row["part_id"])}
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1,
            }}
          >
            {row.existencia_total}
          </TableCell>
          <TableCell
            align="center"
            sx={{
              display: "table-cell",
              fontWeight: 500,
              color: theme.palette.primary.input,
              background: "white",
              p: 1,
            }}
          >
            {row.cliente}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0, marginBottom: 10 }}
            colSpan={6}
          >
            <Collapse in={open} unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Desgloce de contenedores
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Serial
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Etiqueta
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Etiqueta master
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Cantidad
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Fecha reporteo
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Fecha impresión
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ color: theme.palette.primary.main, fontSize: 16 }}
                      >
                        Usuario impresión
                      </TableCell>
                      {canSearch && (
                        <TableCell
                          align="center"
                          sx={{
                            color: theme.palette.primary.main,
                            fontSize: 16,
                          }}
                        ></TableCell>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {movimientos?.map((mov) => (
                      <TableRow key={mov?.moin_id}>
                        <TableCell
                          align="center"
                          sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}
                        >
                          {mov?.moin_serial.length === 1 ? (
                            mov?.moin_serial[0]
                          ) : (
                            <VerSerial
                              key={`serial_${mov?.moin_id}`}
                              data={mov?.moin_serial}
                            />
                          )}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ pl: 1.8, pr: 1.8, pt: 1, pb: 1 }}
                        >
                          {mov?.etiq_codigo}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ pl: 1.8, pr: 1.8, pt: 1, pb: 1 }}
                        >
                          {mov?.etiq_master}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}
                        >
                          {mov?.moin_cantidad}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}
                        >
                          {mov?.moin_fechareportado
                            ? mov?.moin_fechareportado
                            : null}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}
                        >
                          {mov?.etiq_fechaimpresion
                            ? mov?.etiq_fechaimpresion
                            : null}
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}
                        >
                          {mov?.user}
                        </TableCell>
                        {canSearch && areaAlma !== AreaAlmacenEnum.SCRAP && (
                          <TableCell
                            align="center"
                            sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}
                          >
                            <Button
                              variant="contained"
                              key={`certificado_${mov?.etiq_codigo}`}
                              className="btn_system"
                              sx={{ fontSize: 12, height: 35 }}
                              disableElevation
                              onClick={() =>
                                downloadCertificates(mov?.etiq_codigo)
                              }
                            >
                              Certificado
                            </Button>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  return (
    <Paper
      style={{ height: 350, width: "100%", marginBottom: 10 }}
      sx={{ boxShadow: "none" }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: -3,
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: 500 }}
          gutterBottom
          component="div"
        >
          Existencias
        </Typography>
        {canSearch && (
          <TextField
            id="search_entry"
            label="Ingrese palabra clave"
            name="search_entry"
            size="small"
            value={filtro}
            onChange={handleInputChange}
            onKeyDown={onPressEnter}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search sx={{ fontSize: 20 }} />
                </InputAdornment>
              ),
            }}
            sx={{ color: theme.palette.primary.input, mb: 2 }}
          />
        )}
      </div>
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead
            sx={{
              display: "table-head",
              backgroundColor:
                color === "#000" ? theme.palette.primary.main : color,
              fontWeight: 600,
            }}
          >
            <TableRow>
              <TableCell />
              <TableCell align="center" sx={{ color: "white" }}>
                Código
              </TableCell>
              <TableCell align="center" sx={{ color: "white" }}>
                Nombre
              </TableCell>
              <TableCell align="center" sx={{ color: "white" }}>
                Existencia Total
              </TableCell>
              <TableCell align="center" sx={{ color: "white" }}>
                Cliente
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row) => (
              <Row key={`row_${row?.part_id}_${row?.serial}`} row={row} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default TablaGeneral;
